import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const CircleFilledIcon = ({ size, className, ...other }) => (
  /* eslint-disable */

  <div
    className={clsx(
      "em-c-icon",
      {
        "em-c-icon--small": size === "small",
        "em-c-icon--medium": size !== "small" && size !== "large",
        "em-c-icon--large": size === "large"
      },
      "em-icon-wrapper",
      className
    )}
    {...other}
  >
    {size === "small" ? (
      <svg height="100%" width="100%" viewBox="0 0 16 16">
        <circle cx={8} cy={8} r={4} fill="currentColor" />
        <path
          d="M8 13a5 5 0 1 1 5-5 5.006 5.006 0 0 1-5 5zm0-8a3 3 0 1 0 3 3 3 3 0 0 0-3-3z"
          fill="currentColor"
        />
      </svg>
    ) : size === "large" ? (
      <svg height="100%" width="100%" viewBox="0 0 48 48">
        <circle cx={24} cy={24} r={16.5} fill="currentColor" />
        <path
          d="M24 42a18 18 0 1 1 18-18 18.021 18.021 0 0 1-18 18zm0-33a15 15 0 1 0 15 15A15.017 15.017 0 0 0 24 9z"
          fill="currentColor"
        />
      </svg>
    ) : (
      <svg height="100%" width="100%" viewBox="0 0 24 24">
        <circle cx={12} cy={12} r={8.5} fill="currentColor" />
        <path
          d="M12 22a10 10 0 1 1 10-10 10.011 10.011 0 0 1-10 10zm0-17a7 7 0 1 0 7 7 7.008 7.008 0 0 0-7-7z"
          fill="currentColor"
        />
      </svg>
    )}
  </div>

  /* eslint-enable */
);

CircleFilledIcon.propTypes = {
  size: PropTypes.oneOf(["small", "medium", "large"]),

  /** className allows you to append css classes */

  className: PropTypes.string
};

CircleFilledIcon.defaultProps = {
  size: "medium",

  className: ""
};

export default CircleFilledIcon;
